import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export interface ClientKycStatus {
  valid_until: string;
  days_to_expiry: number;
  is_expired: boolean;
  revalidation_required: boolean;
}

export interface ClientProfile {
  client_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  /** True only while the number we proved is still the number on the account. */
  phone_verified: boolean;
  /** The day a money-out hold from a recent number change ends, or null. */
  phone_change_hold_until: string | null;
  member_since: string;
  assigned_agent_id: string | null;
  assigned_agent_name: string | null;
  is_on_roster: boolean;
  kyc_status: ClientKycStatus | null;
  /** The day the client became a former client of the platform (nothing left anywhere past the
   *  grace), or null while they are a client. They keep sign-in and read-only access. */
  former_client_since: string | null;
}

class StaffService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async getClientProfile(clientId: string): Promise<ClientProfile> {
    const res = await this.api.get<ClientProfile>(
      `/api/v1/staff/clients/${clientId}/profile`,
    );
    return res.data;
  }
}

export default new StaffService();
